export const styles = {
  legendColorBox: (color: string) => ({
    width: '2rem',
    height: '1rem',
    backgroundColor: color,
  }),
};
